import { useState } from 'react';
import { MagnifyingGlassMinusIcon, MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline';
import { i18nService } from '../../services/i18n';

/** 产物面板与正文图片共用的阅读器；URL 的授权和清理由调用方负责。 */
export default function ImagePreview({ dataUrl, fileName }: { dataUrl: string; fileName: string }) {
  return <ImageSurface key={dataUrl} dataUrl={dataUrl} fileName={fileName} />;
}

/** 图片更换时重新创建状态，原图超出窗口时可滚动到每个边角。 */
function ImageSurface({ dataUrl, fileName }: { dataUrl: string; fileName: string }) {
  const [fit, setFit] = useState(true);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const label = i18nService.t(fit ? 'imageOriginalSize' : 'imageFitWindow');
  return <div className="relative h-full min-h-0 bg-[#1a1a1a]">
    <button type="button" onClick={() => setFit(value => !value)} title={label} aria-label={label}
      className="absolute top-2 right-2 z-10 rounded-md bg-black/60 p-2 text-white hover:bg-black/80">
      {fit ? <MagnifyingGlassPlusIcon className="h-4 w-4" /> : <MagnifyingGlassMinusIcon className="h-4 w-4" />}
    </button>
    <div className={`h-full overflow-auto ${fit ? 'flex items-center justify-center' : ''}`}>
      {failed ? <div role="alert" className="p-8 text-center text-sm text-white">
        <p>{i18nService.t('imageLoadFailed')}</p>
        <button type="button" className="mt-3 rounded border px-3 py-1" onClick={() => { setFailed(false); setAttempt(value => value + 1); }}>
          {i18nService.t('retry')}
        </button>
      </div> : <img key={attempt} src={dataUrl} alt={fileName} onError={() => setFailed(true)}
        onClick={() => setFit(value => !value)}
        className={fit ? 'max-w-full max-h-full object-contain cursor-zoom-in' : 'block cursor-zoom-out'}
        style={fit ? undefined : { maxWidth: 'none' }} />}
    </div>
  </div>;
}
